<template>
  <div class="user_container">
    <div class="carManageContainer">
      <van-tabs v-model="active" color="#4EA27C" line-height="4px" line-width="20px" @click="toggleTabs">
        <van-tab title="审批中">
          <examine ref="examine" :active="active"></examine>
        </van-tab>
        <van-tab title="待分配">
          <AwaitAllot ref="awaitAllot" :active="active"></AwaitAllot>
        </van-tab>
        <van-tab title="已分配">
          <alreadyAllot ref="alreadyAllot" :active="active"></alreadyAllot>
        </van-tab>
        <van-tab title="已完成">
          <alreadyFinish ref="alreadyFinish" :active="active"></alreadyFinish>
        </van-tab>
        <van-tab title="已取消">
          <alreadyCancel ref="alreadyCancel" :active="active"></alreadyCancel>
        </van-tab>
        <van-tab title="已作废">
          <alreadyInvalid ref="alreadyInvalid" :active="active"></alreadyInvalid>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import examine from "./examine.vue";
import AwaitAllot from "./awaitAllot.vue";
import alreadyAllot from "./alreadyAllot.vue";
import alreadyFinish from "./alreadyFinish.vue";
import alreadyCancel from "./alreadyCancel.vue";
import alreadyInvalid from "./alreadyInvalid.vue";
import "@/assets/car/icon/iconfont.css";
export default {
  name: "useCarApply",
  props: {},
  components: {
    examine,
    AwaitAllot,
    alreadyAllot,
    alreadyFinish,
    alreadyCancel,
    alreadyInvalid
  },
  data() {
    return {
      active: 0
    };
  },
  created() {
    sessionStorage.removeItem("addressInfoList");
    sessionStorage.removeItem("carInfo");
  },
  mounted() {
    // if (this.$route.query.name) {
    //   this.active = Number(this.$route.query.name);
    // }
    // 获取tab选中状态
    this.active = JSON.parse(localStorage.getItem('active'));
    localStorage.removeItem('active');
  },
  methods: {
    // tab切换，请求数据
    toggleTabs() {
      if (this.active === 0 && this.$refs.examine !== undefined) {
        this.$refs.examine.page = 1;
        this.$refs.examine.onLoad();
      } else if (this.active === 1 && this.$refs.awaitAllot !== undefined) {
        this.$refs.awaitAllot.page = 1;
        // this.$refs.awaitAllot.pageSize = 20;
        this.$refs.awaitAllot.onLoad();
      } else if (this.active === 2 && this.$refs.alreadyAllot !== undefined) {
        this.$refs.alreadyAllot.page = 1;
        this.$refs.alreadyAllot.onLoad();
      } else if (this.active === 3 && this.$refs.alreadyFinish !== undefined) {
        this.$refs.alreadyFinish.page = 1;
        this.$refs.alreadyFinish.onLoad();
      } else if (this.active === 4 && this.$refs.alreadyCancel !== undefined) {
        this.$refs.alreadyCancel.page = 1;
        this.$refs.alreadyCancel.onLoad();
      } else if (this.active === 5 && this.$refs.alreadyInvalid !== undefined) {
        this.$refs.alreadyInvalid.page = 1;
        this.$refs.alreadyInvalid.onLoad();
      }
    }
  },
  // activated() {

  //   this.$router.beforeEach((to, from, next) => {

  //     console.log("进来", from.path);
  //     console.log("去", to.path);
  //     if (from.path == "/car/facility/index") {
  //       this.active = 0;
  //     }

  //     if (to.path == '/car/facility/useCarApply') {
  //       // to.path = to.path + '?flush=1';

  //       // localStorage.setItem('isRe', 1);

  //       // eslint-disable-next-line no-undef
  //       this.$bus.$emit("isRe", 1);
  //     }
  //     next();
  //   });

  //   // if (this.active === 0 && this.$refs.examine !== undefined) {
  //   //   this.$refs.examine.queryUseCarAllot();
  //   // } else if (this.active === 1 && this.$refs.awaitAllot !== undefined) {
  //   //   this.$refs.awaitAllot.queryUseCarAllot();
  //   // } else if (this.active === 2 && this.$refs.alreadyAllot !== undefined) {
  //   //   this.$refs.alreadyAllot.queryUseCarAllot();
  //   // } else if (this.active === 3 && this.$refs.alreadyFinish !== undefined) {
  //   //   this.$refs.alreadyFinish.queryUseCarAllot();
  //   // } else if (this.active === 4 && this.$refs.alreadyCancel !== undefined) {
  //   //   this.$refs.alreadyCancel.queryUseCarAllot();
  //   // }
  // }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}

.user_container {
  width: 100%;
  display: flex;
  justify-content: center;

  .carManageContainer {
    width: 100%;
    max-width: 780px;

    ::v-deep(.van-tabs__wrap) {
      height: 105px;
    }

    ::v-deep(.van-tab) {
      font-size: 29px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }

    ::v-deep(.van-tab--active) {
      font-size: 36px;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #282b32;
    }

    ::v-deep(.van-tabs__line) {
      border-radius: 0 !important;
    }
  }
}
</style>
